import React from 'react';
import { Route } from 'react-router';
import CustomRouter from "./Routes";
import CacheBuster from "./components/CacheBuster";
import packageJson from '../package.json';
global.appVersion = packageJson.version;

export default () => (
   <CacheBuster>
        {({ loading, isLatestVersion, refreshCacheAndReload }) => {
          if (loading) return null;
          if (!loading && !isLatestVersion) {
              refreshCacheAndReload();
          }

          return (
            <Route path="*" render={(props) => <CustomRouter { ...props } />} />
          );
        }}
   </CacheBuster>
);
